import {
  createAsyncThunk,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';
import { type Computer } from '~/types';
import { computerAPI } from '~/api';

const getComputers = createAsyncThunk('computers/getComputers', async () => {
  return computerAPI.getAll();
});

export type ComputerState = {
  loading: boolean;
  map: Record<string, Computer>;
  items: string[];
};

const initialState: ComputerState = {
  loading: false,
  map: {},
  items: [],
};

export const computerSlice = createSlice({
  name: 'computers',
  initialState,
  reducers: {
    setComputerStatus: (
      state,
      action: PayloadAction<{ id: string; status: 'online' | 'offline' }>,
    ) => {
      const { id, status } = action.payload;
      state.map[id].status = status;
    },
    addComputer: (state, action: PayloadAction<Computer>) => {
      const computer = action.payload;
      state.map[computer.id] = computer;
      if (!state.items.includes(computer.id)) {
        state.items.push(computer.id);
      }
    },
  },
  extraReducers(builder) {
    builder.addCase(getComputers.fulfilled, (state, action) => {
      const computers = action.payload;
      for (const computer of computers) {
        state.map[computer.id] = computer;
        if (!state.items.includes(computer.id)) {
          state.items.push(computer.id);
        }
      }

      state.loading = false;
    });
    builder.addCase(getComputers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getComputers.rejected, (state) => {
      state.loading = false;
    });
  },
  selectors: {
    getAll: (state) => state.items.map((id) => state.map[id]),
  },
});

export const {
  actions: computerActions,
  reducer: computerReducer,
  selectors: computerSelectors,
} = computerSlice;

export const computerThunks = {
  getComputers,
};
